export default __webpack_public_path__ + "static/media/user.2de19869.svg";